var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_c('h3',{staticClass:"navbar-title"},[_vm._v(" 厂商品牌概况 ")]),_c('breadcrumb',{staticClass:"breadcrumb-container",attrs:{"id":"breadcrumb-container"}}),_c('div',{staticClass:"right-menu"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }